// This function is needed because in javascript modulo of a negative number is negative
// https://stackoverflow.com/questions/4467539/javascript-modulo-gives-a-negative-result-for-negative-numbers
export const safeModulo = (a: number, b: number): number => {
  'use strict'
  return ((a % b) + b) % b
}
